import LoadingPage from "../LoadingPage/LoadingPage";

const CallbackSuccess = () => {
  return <LoadingPage />;
};

export default CallbackSuccess;
